import { NgModule, APP_INITIALIZER } from '@angular/core'
import { CommonModule} from '@angular/common'

import { MovieService } from './movies/movie.service'
// import { AuthService } from './auth/auth.service'
// import { AuthGuard } from './auth/auth-guard'
import { UserService } from './users/user.service'
import { ConversationService } from './conversation/conversation.service'
import { TaskService } from './tasks/task.service'
import { FirebaseService } from './firebase/firebase.service'

import { GoogleMapsAPIWrapper } from '@agm/core'

import { environment } from '../../environments/environment'

@NgModule({
    imports: [
        CommonModule
    ],
    exports: [],
    declarations: [],
    providers: [
        MovieService,
        // AuthService,
        // AuthGuard,
        UserService,
        ConversationService,
        TaskService,
        GoogleMapsAPIWrapper,
        FirebaseService
    ],
})
export class CoreModule {
}

export { FirebaseService }



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/core/core.module.ts